export class ApiUrl {
  //BaseUrl: string = "http://localhost/happyfleetrichielda_api/index.php";
  BaseUrl: string = "https://happyfleetrichielda-api.happyfleets.com/index.php";
  //BaseUrl: string = "http://test-api.happyfleets.com/index.php";
}